var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16667 0C1.69583 0 0.5 1.2332 0.5 2.75V19.25C0.5 20.7668 1.69583 22 3.16667 22H13.8333C15.3042 22 16.5 20.7668 16.5 19.25V6.875H11.1667C10.4292 6.875 9.83333 6.26055 9.83333 5.5V0H3.16667ZM11.1667 0V5.5H16.5L11.1667 0ZM11.8333 13.0625C11.8333 13.8273 11.6292 14.5449 11.2792 15.1637L12.875 16.8094C13.2667 17.2133 13.2667 17.8664 12.875 18.266C12.4833 18.6656 11.85 18.6699 11.4625 18.266L9.8625 16.616C9.26667 16.9813 8.575 17.1875 7.83333 17.1875C5.625 17.1875 3.83333 15.3398 3.83333 13.0625C3.83333 10.7852 5.625 8.9375 7.83333 8.9375C10.0417 8.9375 11.8333 10.7852 11.8333 13.0625ZM7.83333 15.125C8.36377 15.125 8.87247 14.9077 9.24755 14.5209C9.62262 14.1341 9.83333 13.6095 9.83333 13.0625C9.83333 12.5155 9.62262 11.9909 9.24755 11.6041C8.87247 11.2173 8.36377 11 7.83333 11C7.3029 11 6.79419 11.2173 6.41912 11.6041C6.04405 11.9909 5.83333 12.5155 5.83333 13.0625C5.83333 13.6095 6.04405 14.1341 6.41912 14.5209C6.79419 14.9077 7.3029 15.125 7.83333 15.125Z",
    fill: "#091644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.f0f42bbef10cf19e9fdf44ce2dc5ff19.svg";
export { ForwardRef as ReactComponent };